import { Component, Input, SimpleChanges } from '@angular/core';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-top-sell-invoces',
  templateUrl: './top-sell-invoces.component.html',
  styleUrls: ['./top-sell-invoces.component.scss']
})
export class TopSellInvocesComponent {
  public icons = {faCircleMinus, faCircleCheck, faCircleXmark};
  public booleanCargandoSellInvoces = true;
  public booleanVentas = false;
  @Input() topSellInvoices: any;

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['topSellInvoices'] && changes['topSellInvoices'].currentValue !== undefined) {
    }
  }

  getRows(invoces: any[]): any[][] {
    const rows = [];
    for (let i = 0; i < invoces?.length; i += 4) {
      rows.push(invoces.slice(i, i + 4));
    }
    return rows;
  }
}
